export const NudgeCardsCreationConst =
{
    TitleCharacterLimit: 20,
    SubTitleCharacterLimit: 20,
    minLength: 0
};